import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c6aeeda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-red" }
const _hoisted_3 = { class: "text-opacity" }
const _hoisted_4 = { class: "home-footer" }
const _hoisted_5 = { class: "box-botton" }
const _hoisted_6 = { class: "personality-button-container" }
const _hoisted_7 = {
  class: "link-botton",
  style: {"opacity":"0.5"}
}
const _hoisted_8 = { class: "text-botton" }
const _hoisted_9 = { class: "text-botton" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon common-icon-ListNextW" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chain_tag = _resolveComponent("chain-tag")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_layout, null, {
        header: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$checkI18n('home.title')) + "[Obsolete]", 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$checkI18n('home.subtitle')), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "box-botton-bg",
                style: _normalizeStyle({backgroundColor: _ctx.bgColor})
              }, null, 4),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n('home.send')), 1),
                    (_ctx.chainId)
                      ? (_openBlock(), _createBlock(_component_chain_tag, {
                          key: 0,
                          class: "chain-text",
                          chainId: _ctx.chainId
                        }, null, 8, ["chainId"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "link-botton",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toMyRecords && _ctx.toMyRecords(...args)))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n('home.records')), 1)
                  ]),
                  _hoisted_10
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}